import {ServiceEventTargetMode, serviceEventTargetModes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ServiceEventTargetMode>;

export const ServiceEventTargetModeSelect = (props: Props) => {
  const {options = serviceEventTargetModes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
